import React from 'react';

import { NavContext } from '../contexts/NavContext';

export interface FmlRedirectProps {
  path?: string;
  exact?: boolean;
  to: string;
  routerOptions?: unknown;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface FmlRedirectState {}

export class FmlRedirect extends React.PureComponent<FmlRedirectProps, FmlRedirectState> {
  context!: React.ContextType<typeof NavContext>;

  render() {
    const FmlRedirectInner = this.context.getFmlRedirect();

    if (!this.context.hasFamilyRouter() || !FmlRedirect) {
      console.error(
        'You either do not have an Family Router package, or your router does not support using <FmlRedirect>'
      );
      return null;
    }

    return <FmlRedirectInner {...this.props} />;
  }

  static get contextType() {
    return NavContext;
  }
}
